/** Injected into the print iframe by react-to-print. */
export const CITATION_PRINT_PAGE_STYLE = `
  @page {
    size: auto;
    margin: 14mm;
  }
  @media print {
    html, body {
      height: auto !important;
      overflow: visible !important;
      background: #fff !important;
    }
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
`;
